import { Component, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import {
  MultiSelectComponent,
  FilterOption,
} from '../../../../shared/components/ui/multi-select';

@Component({
  selector: 'app-invoices-header',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MultiSelectComponent],
  template: `
    <div class="invoices-header">
      <div class="header-content">
        <h1>Comprobantes</h1>

        <div class="filters-container pr-7">
          <div class="filter-item">
            <app-multi-select
              [options]="documentOptions"
              [formControl]="documentControl"
              class="w-[160px]"
              [fullWidth]="true"
              label="Documento"
              placeholder="Todos"
              (selectionChange)="onDocumentFilterChange($event)"
            >
            </app-multi-select>
          </div>
          <div class="filter-item">
            <app-multi-select
              [options]="receiptTypeOptions"
              [formControl]="receiptTypeControl"
              label="Tipo de comprobante"
              [fullWidth]="true"
              placeholder="Todos"
              class="w-[190px]"
              (selectionChange)="onReceiptTypeFilterChange($event)"
            >
            </app-multi-select>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrl: './invoices-header.component.scss',
})
export class InvoicesHeaderComponent {
  @Output() documentFilterChange = new EventEmitter<string[]>();
  @Output() receiptTypeFilterChange = new EventEmitter<string[]>();

  // Document type options
  documentOptions: FilterOption[] = [
    { value: 'boleta', label: 'Boleta de pago' },
    { value: 'factura', label: 'Factura' },
    { value: 'nota-credito', label: 'Nota de crédito' },
  ];

  // Receipt type options
  receiptTypeOptions: FilterOption[] = [
    { value: 'fisico', label: 'Comprobante Físico' },
    { value: 'virtual', label: 'Comprobante Virtual' },
  ];

  // Form controls - initialized with all values to show "Todos" by default
  documentControl = new FormControl<string[]>(
    this.documentOptions.map(option => option.value)
  );
  receiptTypeControl = new FormControl<string[]>(
    this.receiptTypeOptions.map(option => option.value)
  );

  onDocumentFilterChange(selectedValues: string[]): void {
    this.documentFilterChange.emit(selectedValues);
  }

  onReceiptTypeFilterChange(selectedValues: string[]): void {
    this.receiptTypeFilterChange.emit(selectedValues);
  }
}
